// extracted by mini-css-extract-plugin
export default {"wrapper":"tk6nK","container":"tm1CB"};